import { MessagePriority } from './index';

export interface SystemSettings {
  retentionPeriod: number;
  maxFileSize: number;
  allowedFileTypes: string[];
  autoArchive: boolean;
  archivePeriod: number;
  maxRecipients: number;
  requireAcknowledgment: boolean;
  defaultPriority: MessagePriority;
  workingHours: {
    start: string;
    end: string;
  };
  timezone: string;
}

export const defaultSystemSettings: SystemSettings = {
  retentionPeriod: 30,
  maxFileSize: 10,
  allowedFileTypes: ['pdf', 'doc', 'docx', 'jpg', 'png'],
  autoArchive: true,
  archivePeriod: 90,
  maxRecipients: 100,
  requireAcknowledgment: true,
  defaultPriority: 'MEDIUM',
  workingHours: {
    start: '09:00',
    end: '17:00',
  },
  timezone: 'UTC',
};